import React from "react";
import Synonyms from "./Synonyms";

export default function Meaning(props) {
  console.log(props.meaning);
  return (
    <div className="Meanings">
      <h3>{props.meaning.partOfSpeech}</h3>
      {props.meaning.definitions.map(function (definition, index) {
        return (
          <div key={index}>
            Definition: {definition.definition}
            <Synonyms synonyms={definition.synonyms} />
            <em>{definition.example}</em>
            <br />
          </div>
        );
      })}
    </div>
  );
}
